// import "./components/swiper";
// import './components/youtubeModalInteractions';
$(document).ready(function () {
  // Frequently Asked Questions -- Accordian
  $(".panel-header h5").on("click", function(){
    if ($(".collapse").parents(".ns-accordion-v__item").children(".collapse").hasClass("show")){
      $(".collapse").parents(".ns-accordion-v__item").children(".collapse").stop().slideUp(300);
      $(this).parents(".ns-accordion-v__item").children(".collapse").stop().slideDown(300);
      $(".collapse").parents(".ns-accordion-v__item").removeClass("current");
      $(this).parents(".ns-accordion-v__item").addClass("current");
    }
  });
  $(".counter-box").on("click", function(){
    if($(".ns-accordion-v__item").children(".collapse").hasClass("show")){
      $(".ns-accordion-v__item").children(".collapse").stop().slideUp(300);
      $(this).siblings(".collapse").stop().slideDown(300);
      $(".collapse").parents(".ns-accordion-v__item").removeClass("current");
      $(this).parents(".ns-accordion-v__item").addClass("current");
    }
  });
});

// naskLoader - not required
// window.onload = function () {
//   document.querySelector(".naskLoader").style.display = "none";
//   eleHeader = document.getElementById(idOfHeader);
//   document.addEventListener("scroll", onScroll, false);
// };
// body loaded
window.addEventListener("load", function () {
  document.querySelector("body").classList.add("loaded");
});

function footerParallax(){
  // script to find the height of footer
  $(window).on("load resize", function () {
    var footerHeight = $("footer").height();
    console.log(footerHeight + " footer Height");
    $("main").css("margin-bottom", 100+"vh");
  });
}
if(window.innerWidth > 991){
  footerParallax();
}